import { gql } from '$lib/apollo';
import { POST_FIELDS } from '$components/Feed/gql.js';

export const GET_UNIFIED_TAG_LANDING_PAGE = gql`
  query GetUnifiedTagLandingPage(
    $slug: String
    $gameIds: [UUID!]
    $postsFirst: Int = 0
    $postsAfter: String
    $productsFirst: Int = 0
    $productsAfter: String
  ) {
    tag(slug: $slug) {
      id
      slug
      name
      totalCount
      posts(gameIds: $gameIds, first: $postsFirst, after: $postsAfter) {
        totalCount
        edges {
          node {
            ...PostFields
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      products(gameIds: $gameIds, first: $productsFirst, after: $productsAfter) {
        totalCount
        edges {
          node {
            id
            coaching {
              id
              durationSeconds
              sessions {
                id
              }
              game {
                id
                slug
                logoMain {
                  original {
                    url
                  }
                }
                localizedTitles {
                  en
                }
                artwork {
                  original {
                    url
                  }
                }
              }
              product {
                id
                slug
                name
                description
                cover {
                  original {
                    url
                  }
                }
                pricingOptions {
                  id
                  price
                }
                account {
                  id
                  slug
                }
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
  ${POST_FIELDS}
`;

export const GET_UNIFIED_TAG_BY_SLUG = gql`
  query GetUnifiedTagBySlug($slug: String) {
    tag(slug: $slug) {
      id
      name
      slug
      postCount
      coachingCount
      totalCount
      games {
        edges {
          node {
            id
            slug
            localizedTitles {
              en
            }
            localizedShortTitles {
              en
            }
            logoMain {
              original {
                url
              }
            }
          }
        }
      }
    }
  }
`;
